/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Loader } from 'components';
import { StatusCounter } from './components/StatusCounter/StatusCounter';
import { PerformanceCard } from './components/PerformanceCard/PerformanceCard';
import { PerformanceSection } from './components/PerformanceSection/PerformanceSection';
import { dashboardAPI } from 'services';
import { METRICS_ADVERTISER, METRICS_PUBLISHER } from 'constants';

/*
function createMockData(days, maxValue) {
  return Array.from({ length: days }, (_, index) => {
    return String(Math.floor(Math.random() * (maxValue + 1)));
  });
}
*/

const MOCK_ADVERTISER = {
  active: 12,
  paused: 8,
  suspended: 2,
};

const MOCK_PUBLISHER = {
  monetising: 12,
  pending: 8,
};

/*
const MOCK_GRAPH_ADVERTISER = {
  trends: {
    Installs: 'up',
    CR: 'up',
    Impressions: 'down',
    Clicks: '',
    Cost: 'up',
  },
  values: {
    Installs: 1235500000,
    CR: 1235500000,
    Impressions: 1235500000,
    Clicks: 1235500000,
    Cost: 1235500000,
  },
  change: {
    Installs: 2.56, // % from prev period
    CR: 2.56,
    Impressions: 2.56,
    Clicks: 2.56,
    Cost: 2.56,
  },
  data: {
    Installs: createMockData(45, 80), // [ 23, 33.23, 0, 80, ...]
    CR: createMockData(45, 80),
    Impressions: createMockData(45, 80),
    Clicks: createMockData(45, 80),
    Cost: createMockData(45, 80),
  },
};

const MOCK_GRAPH_PUBLISHER = {
  trends: {
    eCPM: 'up',
    Revenue: 'down',
  },
  values: {
    eCPM: 1235500000,
    Revenue: 1235500000,
  },
  change: {
    eCPM: 2.56,
    Revenue: 10.2,
  },
  data: {
    eCPM: createMockData(45, 80),
    Revenue: createMockData(45, 80),
  },
};
*/

const Publisher = ({ dateFrom$, dateTo$ }) => {
  const timePeriod = { from: dateFrom$?.value, to: dateTo$?.value };

  const statusData = MOCK_PUBLISHER;
  const {
    data: graphData,
    isFetching: isFetchingGraphData,
    isError: isGraphError,
  } = dashboardAPI.useGetPublisherPerformanceCardsQuery(timePeriod, {
    skip: !timePeriod.from || !timePeriod.to,
  });

  return (
    <Wrap>
      <GridWrap cols={2} style={{ height: '100%' }}>
        <VerticalGridWrap cols={2}>
          <StatusCounter
            title='Monetising Apps'
            value={statusData.monetising}
            numCols={1}
            iron='play'
            type='green'
          />
          <StatusCounter
            title='Need SDK Integration'
            value={statusData.pending}
            numCols={1}
            icon='integration'
            type='red'
          />
          {isFetchingGraphData && (
            <LoaderWrap cols={2}>
              <Loader.Local delay={0} />
            </LoaderWrap>
          )}
          {!isFetchingGraphData &&
            graphData &&
            !isGraphError &&
            METRICS_PUBLISHER.map(({ colName, label }) => (
              <PerformanceCard
                key={colName}
                label={label}
                value={graphData.values[colName]}
                trend={graphData.trends[colName]}
                change={graphData.change[colName]}
                data={graphData.data[colName]}
              />
            ))}
        </VerticalGridWrap>
        <PerformanceSection.Publisher dateFrom$={dateFrom$} dateTo$={dateTo$} />
      </GridWrap>
    </Wrap>
  );
};

const Advertiser = ({ dateFrom$, dateTo$ }) => {
  const timePeriod = { from: dateFrom$?.value, to: dateTo$?.value };

  const statusData = MOCK_ADVERTISER;
  const {
    data: graphData,
    isFetching: isFetchingGraphData,
    isError: isGraphError,
  } = dashboardAPI.useGetAdvertiserPerformanceCardsQuery(timePeriod, {
    skip: !timePeriod.from || !timePeriod.to,
  });

  return (
    <Wrap>
      <GridWrap cols={5}>
        <StatusCounter
          title='Active Campaigns'
          value={statusData.active}
          numCols={2}
          icon='play'
          type='green'
        />
        <StatusCounter
          title='Paused'
          value={statusData.paused}
          numCols={2}
          icon='pause'
          type='yellow'
        />
        <StatusCounter
          title='Suspended'
          value={statusData.suspended}
          numCols={1}
          icon='suspended'
          type='red'
        />
        {isFetchingGraphData && (
          <LoaderWrap cols={5}>
            <Loader.Local delay={0} />
          </LoaderWrap>
        )}
        {!isFetchingGraphData &&
          graphData &&
          !isGraphError &&
          METRICS_ADVERTISER.map(({ colName, label }) => (
            <PerformanceCard
              key={colName}
              label={label}
              value={graphData.values[colName]}
              trend={graphData.trends[colName]}
              change={graphData.change[colName]}
              data={graphData.data[colName]}
            />
          ))}
      </GridWrap>
      <Seporator />
      <GridWrap cols={2}>
        <PerformanceSection.Advertiser dateFrom$={dateFrom$} dateTo$={dateTo$} />
      </GridWrap>
    </Wrap>
  );
};

const Wrap = styled.div`
  min-height: 100%;
`;

const Seporator = styled.div`
  height: 8px;
  width: 100%;
`;

const GridWrap = styled.div`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, minmax(0, 1fr))`};
  gap: 8px;

  > * {
    min-width: 0;
  }
`;

const VerticalGridWrap = styled.div`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, minmax(0, 1fr))`};
  grid-template-rows: auto 1fr;
  gap: 8px;

  > * {
    min-width: 0;
  }
`;

const LoaderWrap = styled.div`
  grid-column: ${({ cols }) => `span ${cols}`};
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DashboardMain = {
  Publisher,
  Advertiser,
};
